import { cn as e } from "../shared/utils.js";
import { OverflowProvider as t } from "../shared/overflow/overflow-context.js";
import { useOverflowContainer as n } from "../shared/overflow/use-overflow-container.js";
import { useOverflowItem as r } from "../shared/overflow/use-overflow-item.js";
import { useOverflowSnapshot as i } from "../shared/overflow/use-overflow-snapshot.js";
import { useOverflowMenu as a } from "../shared/overflow/use-overflow-menu.js";
import { useTranslation as o } from "../i18n/hooks.js";
import { breakpointQueries as s } from "../shared/breakpoints.js";
import { useMediaQuery as c } from "../shared/hooks/use-media-query.js";
import { MenuPrimitives as l } from "../menu/menu.js";
import { CheckIcon as u, DotsHorizontalIcon as d } from "@systemeio/icons";
import { forwardRef as f, useLayoutEffect as p, useState as m } from "react";
import { jsx as h, jsxs as g } from "react/jsx-runtime";
import { cva as _ } from "class-variance-authority";
import { createChangeEventDetails as v } from "@base-ui/react/internals/createBaseUIEventDetails";
import { Tabs as y } from "@base-ui/react/tabs";
//#region src/tabbar/tabbar.tsx
var b = _("relative flex min-w-0 items-center gap-0", { variants: { variant: {
	segmented: "bg-bg-primary rounded-md border-border-300 border p-1",
	underline: e("border-border-300 border-b", "[&:has([data-active][data-error])_[data-slot=tabbar-indicator]]:bg-border-error")
} } }), x = _(e("group data-overflowing:hidden relative z-1 flex shrink-0 min-w-0 items-center justify-center gap-1.5 text-base font-normal whitespace-nowrap outline-none [&_svg]:size-5", "text-text-secondary hover:text-text-primary transition-base", "data-active:text-text-primary", "data-error:text-text-error", "data-disabled:text-text-disabled data-disabled:cursor-not-allowed", "focus-visible:focus-ring-primary"), { variants: { variant: {
	segmented: "rounded-md px-4 py-3 data-disabled:bg-transparent",
	underline: "px-3 py-2 data-active:font-medium"
} } }), S = _("transition-base absolute transition-[left,width,top,height,transform,background-color]", { variants: { variant: {
	segmented: "bg-control-disabled rounded-md top-(--active-tab-top) left-(--active-tab-left) z-0 h-(--active-tab-height) w-(--active-tab-width)",
	underline: "bg-border-accent -bottom-px left-(--active-tab-left) h-0.5 w-(--active-tab-width)"
} } }), C = f(({ className: t, ...n }, r) => /* @__PURE__ */ h(y.Root, {
	ref: r,
	className: e("min-w-0", t),
	...n
})), w = f(({ className: t, variant: n = "underline", ...r }, i) => /* @__PURE__ */ h("div", {
	"data-slot": "tabbar-viewport",
	className: "relative -my-1 max-w-full min-w-0 overflow-x-auto py-1",
	onFocusCapture: (e) => {
		let t = e.target;
		t instanceof HTMLElement && t.matches("[role=\"tab\"]") && t.scrollIntoView({
			inline: "nearest",
			block: "nearest"
		});
	},
	children: /* @__PURE__ */ h(y.List, {
		ref: i,
		className: e(b({ variant: n }), "w-max min-w-full", t),
		...r
	})
})), T = f(({ className: t, variant: n = "underline", ...r }, i) => /* @__PURE__ */ h(y.Tab, {
	ref: i,
	className: e(x({ variant: n }), t),
	...r
})), E = f(({ className: t, variant: n = "underline", ...r }, i) => /* @__PURE__ */ h(y.Indicator, {
	"data-slot": "tabbar-indicator",
	"data-testid": "tabbar-indicator",
	ref: i,
	className: e(S({ variant: n }), t),
	...r
})), D = f(({ className: t, ...n }, r) => /* @__PURE__ */ h(y.Panel, {
	ref: r,
	className: e("outline-none", t),
	...n
}));
function O({ overflowToMenu: e, tab: t, tabProps: n, variant: i }) {
	let a = r(String(t.value), 0, void 0, !e);
	return /* @__PURE__ */ h(T, {
		...n,
		"data-error": t.hasError ? "" : void 0,
		disabled: t.disabled,
		ref: a,
		render: (e, n) => /* @__PURE__ */ h("button", {
			type: "button",
			...e,
			children: M(t.children, j(t, n))
		}),
		variant: i,
		value: t.value
	});
}
function k({ moreLabel: t, onSelect: n, selected: r, tabs: o }) {
	let s = i((e) => e.itemVisibility), c = o.filter((e) => s[String(e.value)] === !1), f = c.length > 0, _ = r == null ? void 0 : String(r), v = c.find((e) => String(e.value) === _), [y, b] = m(!1), { ref: S } = a();
	return p(() => {
		f || b(!1);
	}, [f]), p(() => {
		let e = S.current, t = e?.parentElement?.querySelector("[data-slot=tabbar-indicator]");
		!(t instanceof HTMLElement) || !e || v && (t.hidden = !1, t.style.setProperty("--active-tab-left", `${e.offsetLeft}px`), t.style.setProperty("--active-tab-width", `${e.offsetWidth}px`));
	}), /* @__PURE__ */ g(l.Root, {
		open: y && f,
		onOpenChange: b,
		children: [/* @__PURE__ */ g(l.Trigger, {
			ref: S,
			"aria-hidden": !f || void 0,
			tabIndex: f ? 0 : -1,
			"data-active": v ? "" : void 0,
			"data-error": v?.hasError ? "" : void 0,
			className: e(x({ variant: "underline" }), !f && "pointer-events-none invisible absolute"),
			children: [/* @__PURE__ */ h(d, { className: e("size-5 shrink-0", v ? "text-icon-accent" : "text-icon-tertiary") }), t]
		}), /* @__PURE__ */ h(l.Portal, { children: /* @__PURE__ */ h(l.Positioner, {
			className: "z-60",
			align: "end",
			children: /* @__PURE__ */ h(l.Popup, {
				className: "w-60 max-w-(--available-width)",
				children: c.map((e) => {
					let t = String(e.value), r = t === _, i = e.overflowLabel ?? (typeof e.children == "string" || typeof e.children == "number" ? String(e.children) : "");
					return /* @__PURE__ */ g(l.Item, {
						role: "menuitemradio",
						"aria-checked": r,
						disabled: e.disabled,
						state: e.hasError ? "destructive" : "default",
						className: "gap-1.5",
						onClick: () => {
							n(e.value), b(!1);
						},
						children: [/* @__PURE__ */ h("span", {
							className: "min-w-0 flex-1 wrap-break-word",
							children: i
						}), r && /* @__PURE__ */ h(u, { className: "text-icon-accent size-5 shrink-0" })]
					}, t);
				})
			})
		}) })]
	});
}
C.displayName = y.Root.displayName, w.displayName = y.List.displayName, T.displayName = y.Tab.displayName, E.displayName = y.Indicator.displayName, D.displayName = y.Panel.displayName;
var A = Object.assign(function({ children: r, className: i, defaultValue: a, indicatorProps: l, listProps: u, moreLabel: d, onValueChange: f, tabProps: p, tabs: _, value: x, variant: S = "underline", ...w }) {
	let { t: T } = o(), D = d ?? T("public_pages_purchase.global.more"), [A, j] = m(a ?? null), M = x === void 0 ? A : x, N = !!(c(s.isDesktop, { initializeWithValue: !1 }) && S === "underline"), { containerRef: P, contextValue: F } = n({ padding: 0 }), { className: I, ...L } = u ?? {}, R = (e, t) => {
		x === void 0 && j(e), f?.(e, t);
	};
	return /* @__PURE__ */ g(C, {
		...w,
		className: e("min-w-0", i),
		onValueChange: R,
		value: M,
		children: [/* @__PURE__ */ h(t, {
			value: F,
			children: /* @__PURE__ */ h("div", {
				ref: P,
				"data-slot": "tabbar-viewport",
				className: e("relative max-w-full min-w-0", !N && "-my-1 overflow-x-auto py-1"),
				onFocusCapture: (e) => {
					if (N) return;
					let t = e.target;
					t instanceof HTMLElement && t.matches("[role=\"tab\"]") && t.scrollIntoView({
						inline: "nearest",
						block: "nearest"
					});
				},
				children: /* @__PURE__ */ g(y.List, {
					className: e(b({ variant: S }), N ? "w-full *:data-overflowing:hidden" : "w-max min-w-full", I),
					...L,
					children: [
						/* @__PURE__ */ h(E, {
							...l,
							variant: S
						}),
						_.map((e) => /* @__PURE__ */ h(O, {
							overflowToMenu: N,
							tab: e,
							tabProps: p,
							variant: S
						}, String(e.value))),
						N ? /* @__PURE__ */ h(k, {
							moreLabel: D,
							onSelect: (e) => R?.(e, v("none")),
							selected: M,
							tabs: _
						}) : null
					]
				})
			})
		}), r]
	});
}, {
	Root: C,
	List: w,
	Tab: T,
	Indicator: E,
	Panel: D
});
function j(e, t) {
	return t.disabled ? "disabled" : e.hasError ? "error" : t.active ? "active" : "inactive";
}
function M(e, t) {
	return typeof e == "function" ? e(t) : e;
}
//#endregion
export { A as Tabbar };
